import React from "react";
import {Box, Container, InputAdornment, Tab, Tabs, TextField} from "@mui/material";

function TabContent(props) {
  return (
    <Box
      sx = {{p: 2}}
    >
      <Container
        maxWidth = "sm"
        sx = {{flexGrow: 1}}
      >
        <Container
          sx = {{display: "flex", flexGrow: 1, p: 0}}
        >
          <TextField
            disabled
            fullWidth
            inputProps = {{style: {textAlign: "right"}}}
            InputProps = {{
              startAdornment:
                <InputAdornment
                  position = "start"
                >
                  現在の値
                </InputAdornment>,
              endAdornment:
                Boolean(props.unit[props.open]) && toString.call(props.value[props.open]).slice(8, -1).toLowerCase() !== "array" &&
                <InputAdornment
                  position = "end"
                >
                  {props.unit[props.open]}
                </InputAdornment>
            }}
            size = "small"
            sx = {{mb: 4}}
            type = "number"
            value = {toString.call(props.value[props.open]).slice(8, -1).toLowerCase() === "array" ? props.value[props.open][0] || "" : props.value[props.open] || ""}
            variant = "standard"
          />
          {toString.call(props.value[props.open]).slice(8, -1).toLowerCase() === "array" &&
          <TextField
            disabled
            inputProps = {{style: {textAlign: "right"}}}
            InputProps = {{
              startAdornment:
                <InputAdornment position="start">
                  /
                </InputAdornment>,
              endAdornment:
                Boolean(props.unit[props.open]) &&
                <InputAdornment
                  position = "end"
                >
                  {props.unit[props.open]}
                </InputAdornment>
            }}
            size = "small"
            sx = {{width: "50%", mb: 4}}
            type = "number"
            value = {props.value[props.open][1] || ""}
            variant = "standard"
          />}
        </Container>
        {props.data.map((data, i) =>
          <Container
            key = {"vital_" + props.open + "_" + i}
            sx = {{display: "flex", flexGrow: 1, p: 0}}
          >
            <TextField
              disabled
              fullWidth
              inputProps = {{style: {textAlign: "right"}}}
              InputProps = {{
                startAdornment:
                  <InputAdornment
                    position = "start"
                  >
                    {data[0]}
                  </InputAdornment>,
                endAdornment:
                  Boolean(props.unit[props.open]) && toString.call(data[props.open]).slice(8, -1).toLowerCase() !== "array" &&
                  <InputAdornment
                    position = "end"
                  >
                    {props.unit[props.open]}
                  </InputAdornment>
              }}
              size = "small"
              sx = {{mb: 1}}
              type = "number"
              value = {toString.call(data[props.open]).slice(8, -1).toLowerCase() === "array" ? data[props.open][0] || "" : data[props.open] || ""}
              variant = "standard"
            />
            {toString.call(data[props.open]).slice(8, -1).toLowerCase() === "array" &&
            <TextField
              disabled
              inputProps = {{style: {textAlign: "right"}}}
              InputProps = {{
                startAdornment:
                  <InputAdornment
                    position = "start"
                  >
                    /
                  </InputAdornment>,
                endAdornment:
                  Boolean(props.unit[props.open]) &&
                  <InputAdornment
                    position = "end"
                  >
                    {props.unit[props.open]}
                  </InputAdornment>
              }}
              size = "small"
              sx = {{width: "50%", mb: 1}}
              type = "number"
              value = {data[props.open][1] || ""}
              variant = "standard"
            />}
          </Container>
        )}
      </Container>
    </Box>
  );
};

export default function PastVital(props) {
  const [open, setOpen] = React.useState(props.tab);
  return (
    <Box
      sx = {{p: 2, pt: 0}}
    >
      <Tabs
        indicatorColor = "primary"
        onChange = {(e, value) => setOpen(value)}
        value = {open}
        variant = "fullWidth"
      >
        <Tab
          label = "体温"
          sx = {{minWidth: 0}}
          value = {1}
        />
        <Tab
          label = "脈拍"
          sx = {{minWidth: 0}}
          value = {2}
        />
        <Tab
          label = "呼吸"
          sx = {{minWidth: 0}}
          value = {3}
        />
        <Tab
          label = "SPO2"
          sx = {{minWidth: 0}}
          value = {4}
        />
        <Tab
          label = "血圧"
          sx = {{minWidth: 0}}
          value = {5}
        />
      </Tabs>
      <TabContent
        data = {props.data}
        open = {open}
        unit = {[null, "℃", null, null, null, null]}
        value = {props.value}
      />
    </Box>
  );
};
